import { RootStore } from "./rootStore";
import { makeAutoObservable, observable, action, runInAction } from "mobx";
import agent from "../api/agent";
import { IBrokerMarket, IChangeBrokerState } from "../models/broker";
import { toast } from "react-toastify";
import { IBroker } from "../models/company";
import { history } from "../..";
import { IUsers, IChangeState } from "../models/user";
import { showError } from "../util/errorTypeEnumsOptions";
import { IPackageBroker } from "../models/package";

export default class BrokerStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
  }

  @observable brokers: IBrokerMarket[] | null = null;
  @observable loadData = false;
  @observable btEditBroker = false;
  //ojo este broker es para agregar o editar agentes comerciales
  @observable broker: IBroker | null = null;
  @observable loadBroker = false;
  @observable users: IUsers[] = [];
  @observable loadUsers = false;
  @observable loadPackageBroker = false;
  @observable packagesBroker: IPackageBroker[] = [];

  @action changeStateLoadPackageBroker = () => {
    this.loadPackageBroker = !this.loadPackageBroker;
  };

  @action changeStatebtEditBroker = () => {
    this.btEditBroker = !this.btEditBroker;
  };

  @action getDataPackagesBrokers = (id: string) => {
    if (this.packagesBroker.length > 0) {
      let ob: IPackageBroker[] = [];
      this.packagesBroker.map((o) => {
        ob.push(o);
      });
      return ob;
    } else return [{}];
  };

  @action postPackagesBrokers = async (values: any, id: string) => {
    try {
      const res = await agent.Broker.postPackageBrokers(values, id);
      runInAction(() => {
        if (res.length > 0) {
          this.packagesBroker = res;
          toast.success("Datos guardados correctamente");
        }
      });
    } catch (error) {
      showError(error);
    }
  };

  @action getPackagesBrokers = async (id: string) => {
    try {
      const res = await agent.Broker.getPackageBrokers(id);
      runInAction(() => {
        this.packagesBroker = [];
        if (res.length > 0) {
          this.packagesBroker = res;
        }
      });
    } catch (error) {
      showError(error);
    }
    if (!this.loadPackageBroker) this.changeStateLoadPackageBroker();
  };

  @action reset = () => {
    this.loadBroker = false;
    this.loadUsers = false;
  };

  @action getBrokers = async () => {
    try {
      const res = await agent.Broker.getBrokers();
      runInAction(() => {
        this.brokers = res;
        this.loadData = true;
      });
    } catch (error) {
      showError(error);
    }
  };

  @action updateBroker = async (values: any) => {
    this.changeStatebtEditBroker();
    try {
      const res = await agent.Broker.updateBroker(values);
      toast.success("Los datos se han guardado correctamente");
      runInAction(() => {
        this.broker = res;
      });
    } catch (error) {
      showError(error);
    }
    this.changeStatebtEditBroker();
  };

  @action newBroker = async (values: any) => {
    this.changeStatebtEditBroker();
    try {
      const res = await agent.Broker.newBroker(values);
      toast.success("Los datos se han guardado correctamente");
      runInAction(() => {
        this.broker = res;
        history.push(
          `/home/Configuration/Broker/DashboardEditBroker/${this.broker.id}`
        );
      });
    } catch (error) {
      showError(error);
    }
    this.changeStatebtEditBroker();
  };

  @action getBrokerById = async (id: string) => {
    try {
      const res = await agent.Broker.getBrokerById(id);
      runInAction(() => {
        this.broker = res;
        this.loadBroker = true;
        // history.push(`/home/Configuration/Broker/DashboardEditBroker/${id}`);
      });
    } catch (error) {
      showError(error);
    }
  };

  @action editUserBroker = async (id: any, values: any, brokerId: any) => {
    this.rootStore.buttonLoadingStore.changeState();
    try {
      await agent.Broker.editUserBroker(id, values, brokerId);
      toast.success("El usuario se ha actualizado correctamente");
      this.rootStore.modalStore.closeModal();
      this.getUsersBrokerById(this.broker.id);
    } catch (error) {
      showError(error);
    }
    this.rootStore.buttonLoadingStore.changeState();
  };

  @action createUserBroker = async (values: any) => {
    this.rootStore.buttonLoadingStore.changeState();
    try {
      const user = await agent.Broker.createUserByBrokerId(
        this.broker.id,
        values
      );
      if (user) {
        toast.success(
          "Usuario creado satisfactoriamente. Se envía mail para crear contraseña"
        );
        this.rootStore.modalStore.closeModal();
        this.getUsersBrokerById(this.broker.id);
      } else toast.error("UPS! No se pudo crear el usuario");
    } catch (error) {
      showError(error);
    }
    this.rootStore.buttonLoadingStore.changeState();
  };

  @action getUsersBrokerById = async (id: string) => {
    try {
      const us = await agent.Broker.getUsersByBrokerId(id);
      runInAction(() => {
        this.users = us;
      });
    } catch (error) {
      showError(error);
    }
    runInAction(() => {
      this.loadUsers = true;
    });
  };

  @action changeState = async (userChangeState: IChangeState) => {
    try {
      const change = await agent.UserCompany.changeUserState(userChangeState);
      if (change) {
        toast.success("Se ha cambiado el estado correctamente");
        this.getUsersBrokerById(this.broker.id);
      } else toast.error("UPS! No se pudo cambiar el estado");
    } catch (error) {
      toast.error(
        "UPS! Ocurrio un error cambiando el estado, vuelve a intentarlo más tarde"
      );
      showError(error);
    }
  };

  @action getUsersBroker = async () => {
    try {
      const us = await agent.UsersAdminBroker.getUsersBroker(this.broker.id);
      runInAction(() => {
        this.users = us;
      });
    } catch (error) {
      showError(error);
    }
    runInAction(() => {
      this.loadUsers = true;
    });
  };

  @action changeBrokerState = async (brokerChangeState: IChangeBrokerState) => {
    try {
      const change = await agent.Broker.changeBrokerState(brokerChangeState);
      if (change) {
        toast.success("Se ha cambiado el estado correctamente");
        runInAction(() => {
          this.getBrokers();
        });
      } else toast.error("UPS! No se pudo cambiar el estado");
    } catch (error) {
      showError(error);
    }
  };
}
